import React, { useState, useEffect,  } from 'react';
import { TableFooter, TableRow, TablePagination } from '@material-ui/core';
import Pagination from './PaginationMUI';
import { size } from "lodash"

const TableFooterPagination = (props) => {

    const [state,setState] = useState({ 
        rowsPerPage: 20,
        page: 0,
        from: 1,
        to: 20,
    })

    useEffect(() => {
        // Accepte 0 comme valeur valide (ne pas tester la "truthiness")
        if (typeof props.initialPage === "number") {
            setState(prevState => ({ ...prevState, page: props.initialPage }));
        }
    }, [props.initialPage]);

    const handleChangePage = (event, newPage) => {
        const { rowsPerPage } = state;
        let pageOfItems = props.items && props.items.slice(newPage * rowsPerPage, newPage * rowsPerPage + rowsPerPage)

        setState(prevState => ({ ...prevState, page: newPage }));

        props.onChangePage(pageOfItems, newPage, rowsPerPage)
    };

    const handleChangeRowsPerPage = event => {   
        const rowsPerPage = parseInt(event.target.value)
        const page = state.page
        setState(prevState => ({ ...prevState, page: 0, from: 1, rowsPerPage: rowsPerPage}));

        let pageOfItems = props.items && props.items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        props.onChangePage(pageOfItems, page, rowsPerPage)
    };  
        return (
            <TableFooter>
                <TableRow>
                    <TablePagination
                        rowsPerPageOptions={[20, 40, 100]}
                        colSpan={props.colSpan || 7}
                        count={props.count || size(props.items)}
                        rowsPerPage={state.rowsPerPage}
                        page={state.page}
                        SelectProps={{
                            native: true,
                        }}
                        labelDisplayedRows ={({from, to, count}) => `${from}-${to} sur ${count !== -1 ? count : `plus de ${to}`}`}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        ActionsComponent={Pagination}
                        labelRowsPerPage="Lignes par Page"
                    />
                </TableRow>
            </TableFooter>
        );
}

export default TableFooterPagination;